import layout from '@/layout/index.vue'
import layoutEmpty from '@/layout/empty.vue'
export default {
  name: 'group-spm-platform',
  meta: { title: '咨客台', icon: 'el-icon-notification' },

  children: [
    {
      name: 'spm-platform',
      meta: { title: '咨客台', icon: 'el-icon-notification' },

      routers: [
        {
          path: '/platform',
          name: 'platform',
          component: layout,
          children: [
            {
              path: 'index',
              name: 'index',
              component: () => import('@/views/platform/index.vue'),
              meta: { title: '咨客台', vPermission: ['pc-bar-platform:desk-list'] }
            }
          ]
        },
        {
          path: '/platform/desk',
          name: 'platform-desk',
          component: layoutEmpty,
          children: [
            {
              path: 'detail',
              name: 'detail',
              component: () => import('@/views/platform/desk/detail.vue'),
              meta: {
                title: '台位详情',
                vPermission: ['pc-bar-platform:desk-detail']
              },
              props: true
            },
            {
              path: 'desk-open-detail',
              name: 'desk-open-detail',
              component: () => import('@/views/platform/desk/desk-open-detail.vue'),
              meta: {
                title: '消费详情',
                vPermission: ['pc-bar-platform:desk-detail:desk-open']
              },
              props: true
            }
          ]
        }
      ]
    }
  ]
}
